class Range{
    from;
    to;
    step;

    constructor(from = 0,to = 0,step = 1){
        this.from = from;
        this.to = to;
        this.step = step;
    }
    to(to){
        this.to = 0;
        return this;
    }
    step(step = 1){
        this.step = step;
        return this;
    }
    loop(handler){
        if(!handler) return;

        for(let i=this.from;i<this.to;i+=this.step){
            handler(i);
        }
    }
}

Number.prototype.$$loop = function(handler){
    return new Range(0,this,this<0?-1:1).loop(handler);
}